import {
  Home, Users, ListChecks, FolderOpen, ClipboardList, Stethoscope, Pill, ShieldAlert, FileText,
  Banknote, CreditCard, BarChart3, Settings, ChevronDown, Plus, Trash2, ExternalLink, Check, CheckCheck,
  Send, MessageSquare, ChevronRight, ChevronLeft, Search, User, Download, X, XCircle, MoreVertical,
  MoreHorizontal, Pencil, Mail, Phone, LogOut, ArrowLeft, ImagePlus, UserCircle, Bell, AlertTriangle,
  RefreshCw, ArrowLeftRight, ChevronsRight, ChevronsLeft, CheckCircle2, Building2, Briefcase, Clock,
  Calendar, Upload, Eye, Lock, Info, Layers, HeartPulse, Shield, GraduationCap, UserCheck, ListTodo,
  CalendarCheck, Folder, Inbox, AlertCircle,
} from "lucide-react";

// TLScare icon set (Lucide). Keys are the @mui/icons-material names used across the
// dashboard through <Icon $icon="Name" />; GPS Care keeps the MUI icons. A name
// missing here falls back to the MUI icon, so nothing can render blank.
export const LUCIDE_ICONS = {
  Home, Group: Users, People: Users, AddTask: ListChecks, TaskAlt: CheckCircle2, FolderShared: FolderOpen,
  Folder, Assignment: ClipboardList, MedicalServices: Stethoscope, Medication: Pill, GppMaybe: ShieldAlert,
  ListAlt: FileText, PointOfSale: Banknote, Payment: CreditCard, Analytics: BarChart3, Settings,
  ArrowDropDown: ChevronDown, KeyboardArrowDown: ChevronDown, Add: Plus, Delete: Trash2, DeleteForever: Trash2,
  Launch: ExternalLink, Done: Check, DoneAll: CheckCheck, Send, Message: MessageSquare,
  ArrowForwardIos: ChevronRight, KeyboardArrowRight: ChevronRight, ChevronRight, ChevronLeft,
  KeyboardArrowLeft: ChevronLeft, Search, Person: User, PersonRounded: User, AccountCircle: UserCircle,
  Download, Close: X, Clear: X, Cancel: XCircle, MoreVert: MoreVertical, MoreHoriz: MoreHorizontal,
  ModeEdit: Pencil, Edit: Pencil, Mail, Phone, Logout: LogOut, ArrowBack: ArrowLeft,
  AddPhotoAlternate: ImagePlus, NotificationsNone: Bell, Warning: AlertTriangle, ReportProblem: AlertCircle, Sync: RefreshCw,
  SwapHoriz: ArrowLeftRight, KeyboardDoubleArrowRight: ChevronsRight, KeyboardDoubleArrowLeft: ChevronsLeft,
  Business: Building2, Work: Briefcase, Schedule: Clock, CalendarMonth: Calendar, Upload, Visibility: Eye,
  Lock, Info, Layers, MonitorHeart: HeartPulse, Security: Shield, School: GraduationCap, HowToReg: UserCheck,
  FactCheck: ListTodo, EventAvailable: CalendarCheck, Inbox,
};
